"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ControlLegend =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ControlLegend, _React$PureComponent);

  function ControlLegend() {
    _classCallCheck(this, ControlLegend);

    return _possibleConstructorReturn(this, _getPrototypeOf(ControlLegend).apply(this, arguments));
  }

  _createClass(ControlLegend, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          id = _this$props.id,
          aside = _this$props.aside,
          optional = _this$props.optional,
          themeLegend = _this$props.themeLegend;
      var legendClasses = "inline-block ".concat(themeLegend);
      return _react.default.createElement("div", null, _react.default.createElement("legend", {
        htmlFor: id,
        className: legendClasses
      }, text, " ", optional && _react.default.createElement("span", {
        className: "txt-normal"
      }, "(optional)")), aside && _react.default.createElement("span", {
        className: "inline-block ml12"
      }, aside));
    }
  }]);

  return ControlLegend;
}(_react.default.PureComponent);

exports.default = ControlLegend;

_defineProperty(ControlLegend, "propTypes", {
  /** Label text for this control. */
  text: _propTypes.default.string.isRequired,

  /** Element id used to group additional form controls. */
  id: _propTypes.default.string.isRequired,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** If `true`, the text `(optional)` is appended to the label element. */
  optional: _propTypes.default.bool,

  /** Classes to apply to the legend element. */
  themeLegend: _propTypes.default.string
});

_defineProperty(ControlLegend, "defaultProps", {
  themeLegend: 'txt-s txt-bold mb6'
});